// Staff Action Types
export const GET_STAFF_START = 'GET_STAFF_START';
export const GET_STAFF_SUCCESS = 'GET_STAFF_SUCCESS';
export const GET_STAFF_ERROR = 'GET_STAFF_ERROR';

export const ADD_STAFF_START = 'ADD_STAFF_START';
export const ADD_STAFF_SUCCESS = 'ADD_STAFF_SUCCESS';
export const ADD_STAFF_ERROR = 'ADD_STAFF_ERROR';

export const UPDATE_STAFF_START = 'UPDATE_STAFF_START';
export const UPDATE_STAFF_SUCCESS = 'UPDATE_STAFF_SUCCESS';
export const UPDATE_STAFF_ERROR = 'UPDATE_STAFF_ERROR';

export const DELETE_STAFF_START = 'DELETE_STAFF_START';
export const DELETE_STAFF_SUCCESS = 'DELETE_STAFF_SUCCESS';
export const DELETE_STAFF_ERROR = 'DELETE_STAFF_ERROR';
